import { Controller } from "@hotwired/stimulus"
import { showToast } from "../turbo_streams/toast"

// Connects to data-controller="copy"
export default class extends Controller {
  static values = { url: String }

  copyToClipboard(event) {
    event.preventDefault();

    const textarea = document.createElement("textarea");
    textarea.value = this.urlValue;

    // Hide textarea off-screen
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand("copy");
      showToast("Link wurde in die Zwischenablage kopiert!");
    } catch (err) {
      const errorMessage = err?.message || err.toString() || "Unbekannter Fehler";
      showToast(`Kopieren fehlgeschlagen: ${errorMessage}`);
    }

    document.body.removeChild(textarea);
  }
}
